import Environment from "services/environment";
import { destroyMOESession, trackMOEEvent } from "utils/analytics";
import { logoutUser } from "services/profile";

const env = Environment.getEnv();

const clearStorage = () => {
  sessionStorage.clear();
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("trackOrdertoken"); // for track order journey (Data)
  localStorage.removeItem("trackOrdercpqOrderId"); // for track order journey (Data)
  localStorage.removeItem("s-iv-user"); // for ReadOnly Super Admin journey
  destroyMOESession();
  window.location.href = env.selfcareLoginPageBaseUrl;
};

export const handleLogOut = async (moeEventLogMessage, onLogout) => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  if (onLogout) {
    await onLogout();
  }
  const promises = [trackMOEEvent(moeEventLogMessage)];
  if (accessToken && refreshToken) {
    promises.push(
      logoutUser({
        accessToken,
        refreshToken,
        logoutAllSession: false,
      }),
    );
  }
  Promise.all(promises).finally(() => {
    clearStorage();
  });
};
